import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function usePerfionCultureText(
  data: { texts?: object },
) {
  const { localeProperties } = useI18n()

  const { perfionCulture } = localeProperties.value

  return computed(() => {
    const text = data[perfionCulture as keyof typeof data] ?? Object.values(data)[0]
    return text.toString()
  })
}
